import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import {
    MemberState,
    ZinantisRelationshipStatusTypeKeys,
} from '../../../../../types/zinantis/members/membersType';
import Tooltip from '../../../../../muiComponents/Tooltip';
import Flag from '../../../components/Flag';
import Image from '../../../../components/Image';
import Tag from '../../../../../muiComponents/Tag';
import Icon from '../../../../../muiComponents/Icon';
import { useSearchParams } from '../../../../../customHooks/useSearchParams';

interface MemberRowProps {
    member: MemberState;
    visibleSegmentName?: boolean;
    visibleNewMember?: boolean;
}

const MemberRow = (props: MemberRowProps) => {
    const { member, visibleSegmentName, visibleNewMember } = props;

    const { setSearchParam } = useSearchParams({ base64: true });

    const handleCardClick = (cardId: string) => {
        setSearchParam('id', cardId);
    };

    return (
        <TableRow
            key={member.id}
            className={`member-card ${
                member.statusKey ===
                ZinantisRelationshipStatusTypeKeys.DISCONNECTED
                    ? '--disconnected'
                    : ''
            }`}
            onClick={() => handleCardClick(member.id)}
        >
            <TableCell
                sx={{
                    width: '60px',
                    maxWidth: '60px',
                    textAlign: 'center',
                }}
            >
                <Tooltip titleText={member?.status}>
                    <span>
                        <Icon
                            iconName='FiberManualRecord'
                            style={{
                                color: member.statusColor,
                                fontSize: '14px',
                            }}
                        />
                    </span>
                </Tooltip>
            </TableCell>

            <TableCell className='font-weight-600 text-size-16'>
                <div className='flex gap-20'>
                    {member.name}
                    {visibleNewMember && member.isNew && (
                        <span className='member-row__new-tag'>
                            <Tag text='new' color='pink' />
                        </span>
                    )}
                </div>
            </TableCell>
            {visibleSegmentName && (
                <TableCell>{member.accountManagementSegment}</TableCell>
            )}
            <TableCell
                sx={{
                    width: '250px',
                    maxWidth: '250px',
                }}
            >
                <div className='flex gap-5 flex-align-center'>
                    {member.countryCode && (
                        <Flag text={member.country} code={member.countryCode} />
                    )}

                    <p>{member.country}</p>
                </div>
            </TableCell>
            <TableCell
                sx={{
                    width: '120px',
                    maxWidth: '120px',
                }}
            >
                <div className='member__logo-container'>
                    {member.logo ? (
                        <Image className='member__image' src={member.logo} />
                    ) : (
                        <div className='member__logo-name'>
                            <p className='multiline-overflow__2'>
                                {member.name}
                            </p>
                        </div>
                    )}
                </div>
            </TableCell>
        </TableRow>
    );
};

export default MemberRow;
